import { type FC, useState } from "react";
import { useApiCall, ValidationError } from "../api/api";
import type { Project } from "../api/dto";
import type { CheckInPermissions } from "../api/dto/ProjectCheckIn";
import {
  CheckInSettingsFields,
  defaultCheckInPermissions,
  defaultGrantHours,
  isValidGrantHours,
} from "../components/companies/CheckInSettingsFields";
import { Select } from "../components/form/Select";
import { ModalFooter } from "../components/layout/ModalProvider";
import { useRefresh } from "../components/RefreshController";

export const StartCheckInModal: FC<{ projects: Project[] }> = (props) => {
  const { startProjectCheckIn } = useApiCall();
  const refresh = useRefresh();
  const [projectId, setProjectId] = useState<string>(props.projects[0]?.id ?? "");
  const [grantHours, setGrantHours] = useState<number>(defaultGrantHours);
  const [permissions, setPermissions] = useState<CheckInPermissions>(defaultCheckInPermissions);
  const [errors, setErrors] = useState<string[]>([]);

  const save = async () => {
    setErrors([]);
    await startProjectCheckIn(projectId, permissions, grantHours).catch((e) => {
      if (e instanceof ValidationError) {
        setErrors(Object.values(e.errors).flat());
      }
      throw e;
    });
    refresh();
  };

  return (
    <div className={"flex-col space-y-3"}>
      <p className={"text-sm text-slate-600"}>
        Bezoekers die de QR-code scannen krijgen tijdelijk toegang tot het project met de gekozen
        rechten. Je kunt niet meer rechten meegeven dan je zelf hebt.
      </p>
      <Select
        label={"Project"}
        value={projectId}
        options={Object.fromEntries(props.projects.map((p) => [p.id, p.name]))}
        onChange={setProjectId}
      />
      <CheckInSettingsFields
        grantHours={grantHours}
        onGrantHoursChange={setGrantHours}
        permissions={permissions}
        onPermissionsChange={setPermissions}
        errors={errors}
      />
      <ModalFooter
        text={"Check-in starten"}
        disabled={!projectId || !isValidGrantHours(grantHours)}
        onSubmit={save}
      />
    </div>
  );
};
